<template>
	<div>
		<h1>{{form_config.title ? form_config.title : "Formulaire"}}</h1>

		<p v-html="form_config.description" v-if="form_config.description"></p>

		<b-alert v-if="alcors_errors && alcors_errors.length > 0" show variant="warning">
			<div v-for="(value, key) in alcors_errors" :key="key">
				{{key}} : 
				<span v-if="!value.affaire && !value.reseau_renault">Les informations de votre concession et votre code affaire sont manquants. Veuillez contacter le support à l’adresse suivante asfortes@gcr.fr.</span>
				<span v-if="!value.affaire && value.reseau_renault">Votre code affaire est manquant. Veuillez contacter le support à l’adresse suivante asfortes@gcr.fr.</span>
				<span v-if="value.affaire && !value.reseau_renault">Les informations de votre concession sont manquantes. Veuillez contacter le support à l’adresse suivante asfortes@gcr.fr.</span>
			</div>
		</b-alert>
		<div v-show="!html_form">
			<div v-if="forms.length > 0">
				<p>	<b-button @click="getForms" variant="link"><i class="fas fa-sync"></i></b-button>Liste des formulaires à compléter</p>
				<div v-for="group in groupedForms" :key="group.categorie || '_none'">
					<h5 v-if="group.categorie">{{group.categorie}}</h5>
					<div v-for="form in group.forms" v-bind:key="form.id">
						<div v-if="form.active == -1">
							<i style="color:orange" class="fas fa-hourglass-half"></i> {{form.name || form.uid}} : en cours de traitement
						</div>
						<div v-else-if="form.active == 2">
							<i style="color:green" class="fas fa-check"></i> {{form.name || form.uid}}
						</div>
						<div v-else>
							<b-button style="padding-left:0px;" variant="link" @click="get_form(form.uid)">{{form.name || form.uid}}</b-button>{{ form.active == -1 ? "(en cours de traitement)" : "" }}<br />
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				Il n'y a pas de formulaires à compléter.
			</div>
		</div>

        <div v-if="html_form">
			<div v-if="forms.length > 1">
				<b-button @click="get_form(null)" variant="link"><i class="fas fa-sync"></i></b-button>
				<b-button variant="link" @click="html_form = ''; getForms()">Retour à la liste des formulaires</b-button>
				<span v-if='form_config.info'>-</span>
				<b-button v-if='form_config.info' variant="link" v-b-modal="'modal1'">Aide</b-button>
			</div>
			<div v-else>
				<b-button @click="get_form(null)" variant="link"><i class="fas fa-sync"></i></b-button>
				<b-button v-if='form_config.info' variant="link" v-b-modal="'modal1'">Aide</b-button>
			</div>

			<iframe v-show="html_form" width="100%" height="2000" :srcdoc="html_form" id="iframe" sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals"></iframe>
        </div>
		<b-modal v-if='form_config.info'
			:hide-footer="true"
			size="xl"
			:id="'modal1'"
			:title="'Aide'" >
			<div v-html="form_config.info"></div>
		</b-modal>
	</div>
</template>

<script>
	import { uuid } from "vue-uuid";

	import store from "../store";
	import form from "../services/form";
	import users from "../services/users.js";
	import document_service from "../services/document.js";

	export default {
		name: "formulaire",
		data() {
			return {
				form_config: {},
                forms: [],
				url: "",
				alcors_errors: [],
				html_form: "",
				uid: ""
			};
		},
		computed: {
			event() {
				return this.$store.getters.getEvent
			},
			groupedForms() {
				var hasCategorie = this.forms.some(function (f) { return f.categorie; });

				if (!hasCategorie)
					return [{ categorie: null, forms: this.forms }];

				var noCategorie = [];
				var groups = {};

				this.forms.forEach(function (f) {
					if (f.categorie)
					{
						if (!groups[f.categorie])
							groups[f.categorie] = [];
						groups[f.categorie].push(f);
					}
					else
					{
						noCategorie.push(f);
					}
				});

				var result = [];

				if (noCategorie.length > 0)
					result.push({ categorie: null, forms: noCategorie });

				Object.keys(groups).sort(function (a, b) { return a.localeCompare(b); }).forEach(function (categorie) {
					result.push({ categorie: categorie, forms: groups[categorie] });
				});

				return result;
			}
		},
		watch: {
			event: async function (event) {
				if (event.type == "formulaire")
				{
					if (!this.html_form)
					{
						this.getForms();
					}
				}
				if (event.type == "formulaire_done")
				{
					var forms = await form.get();
					this.forms = forms.forms;
					this.html_form = "";
				}
			}
		},
		methods: {
			async onIframeMessage(event) {
				if (!event.data) return;
				if (event.data.type === 'download_ged') {
					const blob = await document_service.getFile(event.data.uid, event.data.libelle, false, 'blob', true);
					this._gedBlob = new Blob([blob], { type: 'application/pdf' });
					this._gedLibelle = event.data.libelle;
					const arrayBuffer = await this._gedBlob.arrayBuffer();
					const iframe = document.getElementById('iframe');
					if (iframe && iframe.contentWindow) {
						iframe.contentWindow.postMessage({ type: 'show_ged_pdf', buffer: arrayBuffer, libelle: event.data.libelle }, '*');
					}
				} else if (event.data.type === 'trigger_download_ged') {
					if (this._gedBlob) {
						const url = URL.createObjectURL(this._gedBlob);
						const a = document.createElement('a');
						a.href = url;
						a.download = this._gedLibelle || 'document.pdf';
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
						setTimeout(() => URL.revokeObjectURL(url), 1000);
					}
				}
			},
			async get_form(uid = null)
			{
				if (uid)
					this.uid = uid;

				this.html_form = " ";
				this.html_form = await form.getForm(this.uid);
			},
			async getForms()
			{
				var forms = await form.get();
				this.alcors_errors = forms.alcors_errors;
				this.forms = forms.forms;

				/*if (this.forms.length == 1)
				{
					this.uid = this.forms[0].uid;
					this.html_form = await form.getForm(this.uid);
				}*/
			}
		},
		mounted() {
			window.addEventListener('message', this.onIframeMessage);
		},
		beforeDestroy() {
			window.removeEventListener('message', this.onIframeMessage);
		},
		created: async function () {
			if (store.state.user.rules && !store.state.user.rules.formulaire) {
				this.$router.push({ name: "profile" });
			}
			
			var response = await users.getSelf(true);
			var client = response.client;
			if (client.details && client.details.formulaire)
				this.form_config = client.details.formulaire;

			if (store.state.user.rules && store.state.user.rules.formulaire_description)
				this.form_config.description = store.state.user.rules.formulaire_description;

			this.getForms();

			if (this.$route.params.id)
			{
				this.get_form(this.$route.params.id);
			}
		},
	};
</script>

<style></style>
